import React, * as r from 'react';

import { ShowPosts, ShowColumn, Post } from '../../types';
import PostParts from '../parts/PostParts';
import PostPartsDummy from '../parts/PostPartsDummy';
import { Stores } from '../../services/store/index';
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"

export default function OneColumnsPosts(props: {
  posts: ShowPosts,
}) {

  const stores = Stores.useContainer()
  const PostCompoment = stores.isDummy === "AllDummy" || stores.isDummy === "PostDummy" ? PostPartsDummy : PostParts

  return (
    <React.Fragment>
      {/* <ResponsiveMasonry
        columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}
      > */}
      <Masonry
        className={'my-gallery-class'}
        columnsCount={1}
      >
        {props.posts.map((post, index) => {
          const postData = post as Post
          return (
            <PostCompoment key={"post" + index}
              post={postData}
            />
          )
        })
        }
      </Masonry>
      {/* </ResponsiveMasonry> */}
    </React.Fragment >
  );
}